export const getWidthHeight = (
  size: string,
): { width: number; height: number } => {
  const [width, height] = size?.split('x') || []
  return {
    width: Number(width || 0),
    height: Number(height || 0),
  }
}
